module.exports = __webpack_public_path__ + "static/media/team-game.105de9dd.png";